import { list } from "../constants/Constants";

function Timeline() {
  return (
    <section id="timeline">
      <div class="container mx-auto space-y-10">
        <div class="md:w-5/6 flex flex-col justify-around mx-6 space-y-4 xlg:w-6/5">
          <h1 class="text-4xl font-bold text-center md:text-5xl md:text-left md:ml-20 lg:ml-32 xlg:ml-60">
            About Me
          </h1>
          <p class="text-center md:text-left md:ml-20 lg:ml-32  xlg:ml-60 text-gray-500 dark:text-gray-400">
            Get ready to explore my captivating portfolio of past projects! From
            stunning designs to innovative web functionalities, each project
            showcases my expertise and commitment to excellence. Join me on this
            inspiring journey through my work, and let's unlock new
            possibilities together.
          </p>
        </div>

        <div>
          <div>
            <ol class="flex flex-row overflow-y-auto lg:mx-48 xlg:mx-72 md:mx-28 mx-10">
              {list.map(({ id,startdate, enddate, title, description }) => (
                <li class="relative mb-6 sm:mb-0 pl-2 py-2">
                  <div class="flex items-center">
                    <div class="z-10 flex items-center justify-center w-6 h-6 bg-blue-100 rounded-full ring-0 ring-white dark:bg-blue-900 sm:ring-8 dark:ring-gray-900 shrink-0">
                      <svg
                        aria-hidden="true"
                        class="w-3 h-3 text-blue-800 dark:text-blue-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    <div class="hidden sm:flex w-full bg-gray-200 h-0.5 dark:bg-gray-700"></div>
                  </div>
                  <div class="mt-3 sm:pr-3">
                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                      {title}
                    </h3>
                    <time class="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
                      Started on {startdate} - Finished on {enddate}
                    </time>
                    <p class="text-base font-normal text-gray-500 dark:text-gray-400">
                      {description}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Timeline;
